var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPushIcon = function SvgPushIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC148",
    d: "M0 .5h36v36H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.895 26.977a2.503 2.503 0 0 0 4.413 0M13.534 9.337a6.458 6.458 0 0 1 11.025 4.567c0 1.007.167 1.953.417 2.922q.105.33.229.622c.387.91 1.453 1.221 2.248 1.808 1.186.88.958 2.76-.03 3.49 0 0-1.594 1.38-9.322 1.38-7.73 0-9.322-1.38-9.322-1.38-.988-.73-1.218-2.61-.03-3.49.795-.587 1.861-.899 2.248-1.808.386-.907.646-2.068.646-3.544 0-1.713.68-3.356 1.891-4.567"
  })));
};
export default SvgPushIcon;